import { s } from '@/theme/tokens';
import { denseTagChipSx, tableTagChipSx } from '@/ui/composites/tags/tagChipStyles';
import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2TagGroupSx = {
  columnGap: s('sm'),
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: `calc(22px * 2 + ${s('sm')})`,
  minWidth: 0,
  overflow: 'hidden',
  rowGap: s('sm'),
} satisfies SxProps<Theme>;

export const tableV2DenseTagGroupSx = {
  ...tableV2TagGroupSx,
} satisfies SxProps<Theme>;

export const tableV2DenseTagChipWrapperSx = {
  flex: '0 1 auto',
  maxWidth: 'min(160px, 100%)',
} satisfies SxProps<Theme>;

export const tableV2TagChipSx = {
  ...tableTagChipSx,
  maxWidth: 'min(160px, 100%)',
} satisfies SxProps<Theme>;

export const tableV2TooltipTagChipSx = {
  ...tableV2TagChipSx,
  maxWidth: 'none',
  '& .MuiChip-label': {
    minWidth: 0,
    overflow: 'hidden',
    px: s('sm'),
    py: s('xxs'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
} satisfies SxProps<Theme>;

export const tableV2DenseTagChipSx = {
  ...denseTagChipSx,
  maxWidth: 'min(160px, 100%)',
} satisfies SxProps<Theme>;
